import { type ReactNode } from 'react';

import { IconButton, Tooltip } from '@material-ui/core';

import { RiInformationLine as InfoIcon } from '@remixicon/react';

type SectionInfoTooltipProps = {
  children: NonNullable<ReactNode>;
};

const SectionInfoTooltipMui = ({ children }: SectionInfoTooltipProps) => (
  <Tooltip title={children} arrow>
    <IconButton size="small" aria-label="More information" data-track-source-anchor="7fbbfd3284;;low">
      <InfoIcon size="1em" aria-hidden="true" />
    </IconButton>
  </Tooltip>
);

SectionInfoTooltipMui.displayName = 'SectionMui.InfoTooltip';

/** @deprecated Legacy MUI copy - migrate consumers to the Encore Section and delete. */
export default SectionInfoTooltipMui;
